module.exports = __webpack_public_path__ + "static/media/wallpad_mb.70496c72.png";